import { useState, useCallback } from "react";

/**
 * A useState replacement for messages shown in MessageBar that forces it to unmount/remount,
 * triggering auto-scroll even when setting the same value.
 *
 * Works with any MessageBar intent: error, warning, success, info.
 */
export function useScrollableMessage<T>(
  initialValue: T,
): [T, (value: T) => void] {
  const [state, setState] = useState<T>(initialValue);

  const setValueWithScroll = useCallback(
    (value: T) => {
      // Force unmount by setting to initial, then remount with new value
      // This triggers MessageBar's mount effect which scrolls
      setState(initialValue);
      requestAnimationFrame(() => setState(value));
    },
    [initialValue],
  );

  return [state, setValueWithScroll];
}